import * as UI from "@iyk/ui"
import * as React from "react"

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"

export type CheckboxProps = Omit<React.ComponentProps<typeof CheckboxPrimitive.Root>, "className">

export const Checkbox = (props: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={UI.cx(
        "peer size-4 shrink-0 rounded-sm outline-none",
        "focus-visible:ring-2 focus-visible:ring-[var(--gray-8)] focus-visible:ring-offset-1",
        "data-[disabled]:cursor-not-allowed data-[disabled]:border-gray-5",
        "border border-gray-7 data-[checked]:border-gray-12",
        "data-[unchecked]:hover:border-gray-10 data-[unchecked]:hover:bg-gray-3",
        "data-[checked]:text-gray-1 data-[checked]:bg-gray-12",
        "data-[invalid]:border-tomato-11"
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <UI.Icon.Check className="size-full scale-[1.3]" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
